import { BcStateForm, BcStateListContext } from '@bayclubs/state';
import {
    ClubModel,
    ContextCourtModel,
    EnumerationModel,
    CategoryOptionsModel,
    CourtTimeSlotModel
} from '@bayclubs/court-booking-employee-api';

export const CORE_FEATURE_KEY = 'cbCore';

import { ClubSelectFormModel } from '../models/club-select-form.model';

export interface CoreStateModel {
    clubs: BcStateListContext<ClubModel>;
    categories: BcStateListContext<EnumerationModel>;
    courtEventStatuses: BcStateListContext<EnumerationModel>;
    tennisCourtTypes: BcStateListContext<EnumerationModel>;
    categoriesOptions: BcStateListContext<CategoryOptionsModel>;
    courtTimeSlots: BcStateListContext<CourtTimeSlotModel>;
    courtVisibilityOptions: BcStateListContext<EnumerationModel>;
    selectedClub: ClubModel;
    selectedClubForm: BcStateForm<ClubSelectFormModel>;
    clubCourts: BcStateListContext<ContextCourtModel>;
}
